export const entdCarouselTagName: "entd-carousel" = "entd-carousel" as const;
